import React from 'react';
import Blocks from './Blocks';
import { IPageFields } from '@/types/contentful';
import classNames from 'classnames';

export function PageBlocks({ pageBlocks }: IPageFields) {
  return (
    <div className="mb-20 flex w-full flex-col gap-y-20 tablet:mb-[120px] tablet:gap-y-[120px]">
      {pageBlocks?.map(({ sys, fields }: any) => {
        const isVariationContainer =
          sys?.contentType?.sys?.id === 'variationContainer';
        const isBodyCopy = sys?.contentType?.sys?.id === 'bodyCopy';

        return (
          <section
            key={sys?.id}
            data-cfid={sys?.id}
            data-testid="page-block"
            className={classNames({
              '-mb-20 tablet:-mb-[120px]': isVariationContainer,
              '-mt-15 tablet:-mt-[90px]': isBodyCopy
            })}
          >
            <Blocks sys={sys} fields={fields} isBodyElement />
          </section>
        );
      })}
    </div>
  );
}
